export default __webpack_public_path__ + "static/Blind-angels-kayla-video-04e5ca4c1d031caeb85bfbdd452f90b2.png";